"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAmaEngineeredPromptSchema = exports.DocumentAmaUploadEngineeredPromptSchema = exports.DocumentAmaQuestionEngineeredPromptSchema = exports.DocumentAmaRawPromptSchema = exports.DocumentAmaUploadRawPromptSchema = exports.DocumentAmaQuestionRawPromptSchema = exports.AthenaSqlGenerationContextMetadataSchema = exports.SqlExplainContextMetadataSchema = exports.SqlGenerationContextMetadataSchema = exports.AthenaSqlGenerationPromptResultSchema = exports.SqlExplainPromptResultSchema = exports.SqlGenerationPromptResultSchema = exports.AthenaSqlGenerationEngineeredPromptSchema = exports.SqlExplainEngineeredPromptSchema = exports.SqlGenerationEngineeredPromptSchema = exports.AthenaSqlGenerationRawPromptSchema = exports.SqlExplainRawPromptSchema = exports.SqlGenerationRawPromptSchema = exports.FinleyAiExtractValuesExtractedTextSchema = exports.FinleyAiExtractedFieldSchema = exports.FinleyAiRequestSchema = exports.TransformExtractionConfigArraySchema = exports.TransformExtractionConfigSchema = exports.FinleyAiTransformSupportedFileExtensionSchema = exports.FinleyAiTransformSupportedFileExtensionIterable = exports.FinleyAiTextractSupportedFileExtensionSchema = exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesPageNumberSupportedFileExt = exports.FinleyAiExtractValuesFileExtToEngineSupport = exports.FinleyAiExtractValuesEngineFileExtSupport = exports.FinleyAiExtractValuesDefaultEngine = exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = exports.FinleyAiExtractValuesSupportedFileExtensionSchema = exports.FinleyAiExtractValuesSupportedFileExtensionIterable = exports.FinleyAiExtractValuesEngineSchema = exports.finleyAiVirtualSheetFormulaQuestionsSchema = exports.finleyAiVirtualSheetFormulaQuestionSchema = exports.FinleyAiTypeSchema = exports.FinleyAiSubTypeSchema = exports.FinleyAiSubTypeIterable = exports.TranformSubTypeSchemaEnum = exports.TranformSubTypeIterable = exports.VirtualSheetConfigSubTypeSchema = exports.VirtualSheetConfigSubTypeIterable = exports.ExtractValuesSubTypeSchema = exports.ExtractValuesSubTypeIterable = exports.DocumentAmaSubTypeSchema = exports.DocumentAmaSubTypeIterable = exports.AthenaSqlGenerationSubTypeSchema = exports.AthenaSqlGenerationSubTypeIterable = void 0;
exports.DocumentAmaUploadPromptResponseSchema = exports.DocumentAmaQuestionPromptResponseSchema = exports.SqlExplainPromptResponseSchema = exports.SqlGenerationPromptResponseSchema = exports.FinleyAiPromptResponseWireSchema = exports.TransformPromptResponseWireSchema = exports.VirtualSheetConfigPromptResponseWireSchema = exports.ExtractJsonPromptResponseWireSchema = exports.DocumentAmaUploadPromptResponseWireSchema = exports.DocumentAmaQuestionPromptResponseWireSchema = exports.SqlExplainPromptResponseWireSchema = exports.SqlGenerationPromptResponseWireSchema = exports.FinleyAiThreadWireSchema = exports.FinleyAiThreadSchema = exports.FinleyAiPromptResponseTerminalStatuses = exports.FinleyAiPromptResponseStatusSchema = exports.FinleyAiPromptResponseStatusIterable = exports.FinleyAiStatusMetadataSchema = exports.FinleyAiPromptResponseWorkleaseSchema = exports.FinleyAiSharedKnowledgeBaseDocumentUploadWorkleaseSchema = exports.FinleyAiContextMetadataSchema = exports.FinleyAiPromptResultSchema = exports.FinleyAiEngineeredPromptSchema = exports.FinleyAiRawPromptSchema = exports.TransformContextMetadataSchema = exports.TransformPromptResultSchema = exports.TransformEngineeredPromptSchema = exports.TransformRawPromptSchema = exports.VirtualSheetConfigGenerationContextMetadataSchema = exports.VirtualSheetConfigContextMetadataSchema = exports.VirtualSheetConfigGenerationPromptResultSchema = exports.VirtualSheetConfigPromptResultSchema = exports.VirtualSheetConfigGenerationEngineeredPromptSchema = exports.VirtualSheetConfigEngineeredPromptSchema = exports.VirtualSheetConfigGenerationRawPromptSchema = exports.VirtualSheetConfigRawPromptSchema = exports.ExtractValuesContextMetadataSchema = exports.ExtractJsonContextMetadataSchema = exports.ExtractValuesPromptResultSchema = exports.ExtractJsonPromptResultSchema = exports.ExtractValuesEngineeredPromptSchema = exports.ExtractJsonEngineeredPromptSchema = exports.ExtractValuesRawPromptSchema = exports.ExtractJsonRawPromptSchema = exports.DocumentAmaContextMetadataSchema = exports.DocumentAmaUploadContextMetadataSchema = exports.DocumentAmaQuestionContextMetadataSchema = exports.DocumentAmaPromptResultSchema = exports.DocumentAmaUploadPromptResultSchema = exports.DocumentAmaQuestionPromptResultSchema = void 0;
exports.FinleyAiKnowledgeBaseDocumentSchema = exports.FinleyAiPromptTemplateSchema = exports.FinleyAiThreadWithPromptResponsesSchema = exports.TranformWithPromptResponsesSchema = exports.VirtualSheetConfigWithPromptResponsesSchema = exports.ExtractValuesWithPromptResponsesSchema = exports.DocumentAmaThreadWithPromptResponsesSchema = exports.AthenaSqlGenerationThreadWithPromptResponsesSchema = exports.FinleyAiThreadWithPromptResponsesWireSchema = exports.TranformWithPromptResponsesWireSchema = exports.VirtualSheetConfigWithPromptResponsesWireSchema = exports.ExtractValuesWithPromptResponsesWireSchema = exports.DocumentAmaThreadWithPromptResponsesWireSchema = exports.AthenaSqlGenerationThreadWithPromptResponsesWireSchema = exports.FinleyAiPromptResponseSchema = exports.TransformPromptResponseSchema = exports.VirtualSheetConfigPromptResponseSchema = exports.ExtractJsonPromptResponseSchema = void 0;
const zod_1 = require("zod");
const typeguardUtils_1 = require("../typeguards/typeguardUtils");
// Zod schemas for SubType enums
exports.AthenaSqlGenerationSubTypeIterable = [
    'sqlGeneration',
    'sqlExplain',
];
exports.AthenaSqlGenerationSubTypeSchema = zod_1.z.enum(exports.AthenaSqlGenerationSubTypeIterable);
exports.DocumentAmaSubTypeIterable = ['question', 'upload'];
exports.DocumentAmaSubTypeSchema = zod_1.z.enum(exports.DocumentAmaSubTypeIterable);
exports.ExtractValuesSubTypeIterable = ['extractJson'];
exports.ExtractValuesSubTypeSchema = zod_1.z.enum(exports.ExtractValuesSubTypeIterable);
exports.VirtualSheetConfigSubTypeIterable = [
    'generateVirtualSheetConfig', // generate initial config for virtual sheet
    'modifyVirtualSheetConfig', // modify existing virtual sheet config
];
exports.VirtualSheetConfigSubTypeSchema = zod_1.z.enum(exports.VirtualSheetConfigSubTypeIterable);
exports.TranformSubTypeIterable = [
    'generalTransform',
    'financialStatement',
];
// Note: TranformSubTypeSchema already exists later in file, using a different name here
exports.TranformSubTypeSchemaEnum = zod_1.z.enum(exports.TranformSubTypeIterable);
// Combined FinleyAiSubType
exports.FinleyAiSubTypeIterable = [
    ...exports.AthenaSqlGenerationSubTypeIterable,
    ...exports.DocumentAmaSubTypeIterable,
    ...exports.ExtractValuesSubTypeIterable,
    ...exports.VirtualSheetConfigSubTypeIterable,
    ...exports.TranformSubTypeIterable,
];
exports.FinleyAiSubTypeSchema = zod_1.z.enum(exports.FinleyAiSubTypeIterable);
// Zod schema for FinleyAiType - used by table definition schemas
exports.FinleyAiTypeSchema = zod_1.z.enum([
    'athenaSqlGeneration',
    'documentAma',
    'extractValues',
    'virtualSheetConfig',
    'transform',
]);
exports.finleyAiVirtualSheetFormulaQuestionSchema = zod_1.z.object({
    fieldName: zod_1.z.string(), // name of the field to extract
    fieldPrompt: zod_1.z.string(), // question to ask the LLM for the field.
});
exports.finleyAiVirtualSheetFormulaQuestionsSchema = zod_1.z
    .array(exports.finleyAiVirtualSheetFormulaQuestionSchema)
    .min(1);
exports.FinleyAiExtractValuesEngineSchema = zod_1.z.enum([
    'pdfMiner',
    'textract',
    'beautifulSoup',
    'rawText',
]);
exports.FinleyAiExtractValuesSupportedFileExtensionIterable = [
    'pdf',
    'html',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
    'txt',
    'json',
];
exports.FinleyAiExtractValuesSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiExtractValuesSupportedFileExtensionIterable);
exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = Object.freeze(['xlsx', 'xlsb', 'xlsm']);
exports.FinleyAiExtractValuesDefaultEngine = {
    html: 'beautifulSoup',
    pdf: 'pdfMiner',
    jpeg: 'textract',
    jpg: 'textract',
    json: 'rawText',
    png: 'textract',
    tif: 'textract',
    tiff: 'textract',
    txt: 'rawText',
};
exports.FinleyAiExtractValuesEngineFileExtSupport = {
    beautifulSoup: ['html'],
    textract: ['pdf', 'png', 'jpeg', 'jpg', 'tif', 'tiff'],
    pdfMiner: ['pdf'],
    rawText: ['txt', 'json'],
};
// reverse map of FinleyAiExtractValuesEngineFileExtSupport
exports.FinleyAiExtractValuesFileExtToEngineSupport = Object.entries(exports.FinleyAiExtractValuesEngineFileExtSupport).reduce((acc, [eng, exts]) => {
    exts.forEach((ext) => {
        acc[ext].push(eng); // guaranteed by type system, Object.entries loses typing
    });
    return acc;
}, {
    html: [],
    pdf: [],
    png: [],
    jpeg: [],
    jpg: [],
    json: [],
    tiff: [],
    tif: [],
    txt: [],
});
exports.FinleyAiExtractValuesPageNumberSupportedFileExt = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
];
exports.FinleyAiTextractSupportedFileExtensionIterable = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tif',
    'tiff',
];
exports.FinleyAiTextractSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiTextractSupportedFileExtensionIterable);
exports.FinleyAiTransformSupportedFileExtensionIterable = [
    'pdf',
    'html',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
    'json',
    'csv',
    'xlsx',
    'xlsb',
];
exports.FinleyAiTransformSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiTransformSupportedFileExtensionIterable);
// Zod schemas for TransformExtractionConfig
const SheetExtractionConfigSchema = zod_1.z.object({
    sheetName: zod_1.z.string(),
    /** Default: 1 */
    startRow: zod_1.z.number().int().optional(),
    /** Default: all rows */
    endRow: zod_1.z.number().int().optional(),
    /** Default: all columns, or "A:E" notation */
    columns: zod_1.z.string().optional(),
});
const CsvExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('csv'),
});
const JsonExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('json'),
});
const PdfExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('pdf'),
    engine: zod_1.z.enum(['pdfMiner', 'textract']).optional(),
    pages: zod_1.z.array(zod_1.z.number().int()).optional(),
});
const HtmlExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('html'),
    /**
     * Default: 'beautifulSoup'
     * 'raw' passes HTML directly to LLM
     */
    engine: zod_1.z.enum(['beautifulSoup', 'raw']).optional(),
});
const ImageExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.enum(['png', 'jpeg', 'jpg', 'tif', 'tiff']),
    /** Default: 'textract' */
    engine: zod_1.z.literal('textract').optional(),
});
const XlsxExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('xlsx'),
    /** Default: 'openpyxl' (only supported engine currently) */
    engine: zod_1.z.literal('openpyxl').optional(),
    /**
     * Preferably always configured,
     * but not enforced
     */
    sheets: zod_1.z.array(SheetExtractionConfigSchema).optional(),
});
const XlsbExtractionSchema = zod_1.z.object({
    fileExt: zod_1.z.literal('xlsb'),
    /** Default: 'pyxlsb' (only supported engine currently) */
    engine: zod_1.z.literal('pyxlsb').optional(),
    /**
     * Preferably always configured,
     * but not enforced
     */
    sheets: zod_1.z.array(SheetExtractionConfigSchema).optional(),
});
const ExtractionSchema = zod_1.z.union([
    CsvExtractionSchema,
    JsonExtractionSchema,
    PdfExtractionSchema,
    HtmlExtractionSchema,
    ImageExtractionSchema,
    XlsxExtractionSchema,
    XlsbExtractionSchema,
]);
exports.TransformExtractionConfigSchema = zod_1.z.object({
    s3Bucket: zod_1.z.string(),
    s3Key: zod_1.z.string(),
    extraction: ExtractionSchema.optional(),
    documentName: zod_1.z.string(),
});
exports.TransformExtractionConfigArraySchema = zod_1.z.array(exports.TransformExtractionConfigSchema);
// Zod schemas for FinleyAiRequest
const AbstractFinleyAiRequestSchema = zod_1.z.object({
    finleyAiThreadId: zod_1.z.string().nullable(),
    targetOrganizationId: zod_1.z.string(),
});
const SqlGenerationRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    prompt: zod_1.z.string(),
    tableNames: zod_1.z.array(zod_1.z.string()),
    promptTemplate: zod_1.z.string().nullable(),
});
const SqlExplainRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    sql: zod_1.z.string(),
});
const VirtualSheetConfigModificationRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('modifyVirtualSheetConfig'),
    prompt: zod_1.z.string(),
    finleyAiThreadId: zod_1.z.string(), // required for modifications, not nullable
});
const VirtualSheetConfigGenerationRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    finleyAiThreadId: zod_1.z.null(),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    questionConfigs: exports.finleyAiVirtualSheetFormulaQuestionsSchema,
    prompt: zod_1.z.string().nullable(),
});
const DocumentAmaQuestionRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    prompt: zod_1.z.string(),
    knowledgeBaseDocumentIds: zod_1.z.array(zod_1.z.string()),
    tool: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).nullish(),
    keywords: zod_1.z.array(zod_1.z.string()).nullish(),
});
const DocumentAmaUploadRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    documentName: zod_1.z.string(),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    documentType: zod_1.z.literal('userProvided'),
    tags: zod_1.z.array(zod_1.z.string()),
});
const FinleyAiExtractedValueQuestionConfigDataTypeSchema = zod_1.z.enum([
    'string',
    'integer',
    'float',
    'boolean',
]);
const FinleyAiExtractedValueQuestionConfigSchema = zod_1.z.object({
    question: zod_1.z.string(),
    fieldName: zod_1.z.string(),
    type: FinleyAiExtractedValueQuestionConfigDataTypeSchema,
});
const ExtractJsonRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    questionConfigs: zod_1.z.array(FinleyAiExtractedValueQuestionConfigSchema),
    extractionEngine: zod_1.z.union([exports.FinleyAiExtractValuesEngineSchema, zod_1.z.literal('default')]),
    usePages: zod_1.z.array(zod_1.z.number()).optional(),
});
const LLMConfigSchema = zod_1.z.object({
    modelId: zod_1.z
        .enum([
        'anthropic.claude-3-5-sonnet-20240620-v1:0',
        'us.anthropic.claude-sonnet-4-20250514-v1:0',
        'us.anthropic.claude-sonnet-4-5-20250929-v1:0',
    ])
        .optional(),
});
const TransformOutputSchema = zod_1.z.enum(['csv', 'json']);
// TranformSubTypeSchema moved to top of file as TranformSubTypeSchemaEnum
const TranformRequestSchema = AbstractFinleyAiRequestSchema.extend({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    prompt: zod_1.z.string(),
    llm: LLMConfigSchema.optional(),
    output: TransformOutputSchema.optional(),
    tool: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
    documents: zod_1.z.array(exports.TransformExtractionConfigSchema),
});
exports.FinleyAiRequestSchema = zod_1.z.union([
    SqlGenerationRequestSchema,
    VirtualSheetConfigModificationRequestSchema,
    VirtualSheetConfigGenerationRequestSchema,
    SqlExplainRequestSchema,
    DocumentAmaQuestionRequestSchema,
    DocumentAmaUploadRequestSchema,
    ExtractJsonRequestSchema,
    TranformRequestSchema,
]);
// #############
// ## IMPORTANT: this jsonschema (and descriptions) are used in a Finley AI tool.
// ## Altering these descriptions may impact model behavior.
// #############
exports.FinleyAiExtractedFieldSchema = zod_1.z.object({
    /**
     * The name of this field
     */
    fieldName: zod_1.z.string(),
    /**
     * The answer to the question for this fieldName.  If you you cannot confidently answer the question, use a value of null.
     */
    value: zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.null()]),
    /**
     * The page number of the answer to the question for this fieldName.  If no page number details are available, use a value of null.  Do not factor the ability to find a page number into the confidence property.
     */
    pageNumber: zod_1.z.number().int().nullable(),
    /**
     * The confidence number (0-100) for the value you provided for this fieldName.  If you were unable to answer the question, use a value of null.
     */
    confidence: zod_1.z.number().nullable(),
    /**
     * If you are unable to answer the question for this fieldName, provide a message why you could not answer the question.
     */
    error: zod_1.z.string().nullable(),
});
// extractedTextS3Path stores a pointer to a json with this schema
exports.FinleyAiExtractValuesExtractedTextSchema = zod_1.z.object({
    pageNumber: zod_1.z.number().int().nullable(), // page number is not guaranteed to exist for some file types
    text: zod_1.z.string(),
});
/**
 * ************************************
 * ZOD SCHEMAS FOR PROMPT RESPONSE TYPES
 * These schemas mirror the interface-based types above
 * ************************************
 */
// Base abstract schemas (kept for reference, not used directly)
// const AbstractFinleyAiTypeSchema = z.object({
//   type: FinleyAiTypeSchema,
//   subType: FinleyAiSubTypeSchema,
// });
// const AbstractRawPromptSchema = AbstractFinleyAiTypeSchema.extend({ prompt: z.string() });
// const AbstractEngineeredPromptSchema = AbstractFinleyAiTypeSchema.extend({ prompt: z.string() });
// const AbstractPromptResultSchema = AbstractFinleyAiTypeSchema.extend({ response: z.string() });
// --- SQL GENERATION SCHEMAS ---
exports.SqlGenerationRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    prompt: zod_1.z.string(),
    promptTemplate: zod_1.z.string().nullable(),
});
exports.SqlExplainRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    prompt: zod_1.z.string(),
});
exports.AthenaSqlGenerationRawPromptSchema = zod_1.z.union([
    exports.SqlGenerationRawPromptSchema,
    exports.SqlExplainRawPromptSchema,
]);
exports.SqlGenerationEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    prompt: zod_1.z.string(),
});
exports.SqlExplainEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    prompt: zod_1.z.string(),
});
exports.AthenaSqlGenerationEngineeredPromptSchema = zod_1.z.union([
    exports.SqlGenerationEngineeredPromptSchema,
    exports.SqlExplainEngineeredPromptSchema,
]);
exports.SqlGenerationPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    response: zod_1.z.string(),
    sql: zod_1.z.string().nullable(),
    queryResultCsvS3Bucket: zod_1.z.string().nullable(),
    queryResultCsvS3Path: zod_1.z.string().nullable(),
});
exports.SqlExplainPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    response: zod_1.z.string(),
});
exports.AthenaSqlGenerationPromptResultSchema = zod_1.z.union([
    exports.SqlGenerationPromptResultSchema,
    exports.SqlExplainPromptResultSchema,
]);
// AthenaTable schema for context metadata
const AthenaTablePropertyTypeSchema = zod_1.z.enum([
    'array',
    'bigint',
    'binary',
    'boolean',
    'char',
    'date',
    'decimal',
    'double',
    'float',
    'int',
    'integer',
    'map',
    'smallint',
    'string',
    'struct',
    'timestamp',
    'tinyint',
    'varchar',
]);
const AthenaTableSchema = zod_1.z.object({
    tableName: zod_1.z.string(),
    properties: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.string(),
        type: AthenaTablePropertyTypeSchema,
    })),
});
exports.SqlGenerationContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    tables: zod_1.z.array(AthenaTableSchema),
    finleyDatalakePrefixes: zod_1.z.array(zod_1.z.string()),
    athenaDatalakeBucket: zod_1.z.string(),
});
exports.SqlExplainContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    sql: zod_1.z.string(),
});
exports.AthenaSqlGenerationContextMetadataSchema = zod_1.z.union([
    exports.SqlGenerationContextMetadataSchema,
    exports.SqlExplainContextMetadataSchema,
]);
// --- DOCUMENT AMA SCHEMAS ---
exports.DocumentAmaQuestionRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    prompt: zod_1.z.string(),
});
exports.DocumentAmaUploadRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    prompt: zod_1.z.string(),
});
exports.DocumentAmaRawPromptSchema = zod_1.z.union([
    exports.DocumentAmaQuestionRawPromptSchema,
    exports.DocumentAmaUploadRawPromptSchema,
]);
const FinleyAiKnowledgeBaseDocumentChunkSchema = zod_1.z.object({
    openSearchId: zod_1.z.string(),
    knowledgeBaseDocumentId: zod_1.z.string(),
    text: zod_1.z.string(),
    pageNum: zod_1.z.number().int(),
});
exports.DocumentAmaQuestionEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    prompt: zod_1.z.string(),
    retrievedChunks: zod_1.z.array(FinleyAiKnowledgeBaseDocumentChunkSchema),
    keywords: zod_1.z.array(zod_1.z.string()),
});
exports.DocumentAmaUploadEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    prompt: zod_1.z.string(),
});
exports.DocumentAmaEngineeredPromptSchema = zod_1.z.union([
    exports.DocumentAmaQuestionEngineeredPromptSchema,
    exports.DocumentAmaUploadEngineeredPromptSchema,
]);
exports.DocumentAmaQuestionPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    response: zod_1.z.string(),
    openSearchIds: zod_1.z.array(zod_1.z.string()).nullable(),
    toolInput: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).nullish(),
});
exports.DocumentAmaUploadPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    response: zod_1.z.string(),
    knowledgeBaseDocumentId: zod_1.z.string().nullable(),
    embeddedChunksS3Bucket: zod_1.z.string().nullable(),
    embeddedChunksS3Path: zod_1.z.string().nullable(),
});
exports.DocumentAmaPromptResultSchema = zod_1.z.union([
    exports.DocumentAmaQuestionPromptResultSchema,
    exports.DocumentAmaUploadPromptResultSchema,
]);
exports.DocumentAmaQuestionContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    knowledgeBaseDocumentIds: zod_1.z.array(zod_1.z.string()),
    numberOfSearchResults: zod_1.z.number().int(),
    tool: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).nullish(),
    keywords: zod_1.z.array(zod_1.z.string()).nullish(),
});
exports.DocumentAmaUploadContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    documentName: zod_1.z.string(),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    documentType: zod_1.z.literal('userProvided'),
    tags: zod_1.z.array(zod_1.z.string()),
});
exports.DocumentAmaContextMetadataSchema = zod_1.z.union([
    exports.DocumentAmaQuestionContextMetadataSchema,
    exports.DocumentAmaUploadContextMetadataSchema,
]);
// --- EXTRACT VALUES SCHEMAS ---
exports.ExtractJsonRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    prompt: zod_1.z.string(),
});
exports.ExtractValuesRawPromptSchema = exports.ExtractJsonRawPromptSchema;
exports.ExtractJsonEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    prompt: zod_1.z.string(),
});
exports.ExtractValuesEngineeredPromptSchema = exports.ExtractJsonEngineeredPromptSchema;
exports.ExtractJsonPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    response: zod_1.z.string(),
    jsonResult: zod_1.z.array(exports.FinleyAiExtractedFieldSchema).nullable(),
    extractedTextS3Bucket: zod_1.z.string().nullable(),
    extractedTextS3Path: zod_1.z.string().nullable(),
});
exports.ExtractValuesPromptResultSchema = exports.ExtractJsonPromptResultSchema;
exports.ExtractJsonContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    questionConfigs: zod_1.z.array(FinleyAiExtractedValueQuestionConfigSchema),
    usePages: zod_1.z.array(zod_1.z.number().int()).optional(),
    extractionEngine: exports.FinleyAiExtractValuesEngineSchema,
    orgSlug: zod_1.z.string(),
});
exports.ExtractValuesContextMetadataSchema = exports.ExtractJsonContextMetadataSchema;
// --- VIRTUAL SHEET CONFIG SCHEMAS ---
exports.VirtualSheetConfigRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    prompt: zod_1.z.string(),
});
exports.VirtualSheetConfigGenerationRawPromptSchema = exports.VirtualSheetConfigRawPromptSchema;
const ConversationMessageSchema = zod_1.z.object({
    role: zod_1.z.enum(['user', 'assistant']),
    content: zod_1.z.string(),
});
exports.VirtualSheetConfigEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    prompt: zod_1.z.string(),
    conversation: zod_1.z.array(ConversationMessageSchema),
});
exports.VirtualSheetConfigGenerationEngineeredPromptSchema = exports.VirtualSheetConfigEngineeredPromptSchema;
const FinleyAiVirtualSheetFormulaAnswerSchema = zod_1.z.object({
    fieldName: zod_1.z.string(),
    formula: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    error: zod_1.z.string().nullable(),
});
exports.VirtualSheetConfigPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    response: zod_1.z.string(),
    answers: zod_1.z.array(FinleyAiVirtualSheetFormulaAnswerSchema).nullable(),
    generatedXlsxS3Bucket: zod_1.z.string(),
    generatedXlsxS3Path: zod_1.z.string(),
});
exports.VirtualSheetConfigGenerationPromptResultSchema = exports.VirtualSheetConfigPromptResultSchema;
exports.VirtualSheetConfigContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    questionConfigs: exports.finleyAiVirtualSheetFormulaQuestionsSchema,
});
exports.VirtualSheetConfigGenerationContextMetadataSchema = exports.VirtualSheetConfigContextMetadataSchema;
// --- TRANSFORM SCHEMAS ---
exports.TransformRawPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    prompt: zod_1.z.string(),
});
exports.TransformEngineeredPromptSchema = zod_1.z.object({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    prompt: zod_1.z.string(),
    extractedTextS3Bucket: zod_1.z.string(),
    extractedTextS3Key: zod_1.z.string(),
});
exports.TransformPromptResultSchema = zod_1.z.object({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    response: zod_1.z.string(),
    resultS3Bucket: zod_1.z.string().nullable(),
    resultS3Key: zod_1.z.string().nullable(),
});
exports.TransformContextMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    orgSlug: zod_1.z.string(),
    llm: LLMConfigSchema.optional(),
    documents: zod_1.z.array(exports.TransformExtractionConfigSchema),
    output: TransformOutputSchema.optional(),
    tool: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
});
// --- UNION SCHEMAS ---
exports.FinleyAiRawPromptSchema = zod_1.z.union([
    exports.SqlGenerationRawPromptSchema,
    exports.SqlExplainRawPromptSchema,
    exports.DocumentAmaQuestionRawPromptSchema,
    exports.DocumentAmaUploadRawPromptSchema,
    exports.ExtractJsonRawPromptSchema,
    exports.VirtualSheetConfigRawPromptSchema,
    exports.TransformRawPromptSchema,
]);
exports.FinleyAiEngineeredPromptSchema = zod_1.z.union([
    exports.SqlGenerationEngineeredPromptSchema,
    exports.SqlExplainEngineeredPromptSchema,
    exports.DocumentAmaQuestionEngineeredPromptSchema,
    exports.DocumentAmaUploadEngineeredPromptSchema,
    exports.ExtractJsonEngineeredPromptSchema,
    exports.VirtualSheetConfigEngineeredPromptSchema,
    exports.TransformEngineeredPromptSchema,
]);
exports.FinleyAiPromptResultSchema = zod_1.z.union([
    exports.SqlGenerationPromptResultSchema,
    exports.SqlExplainPromptResultSchema,
    exports.DocumentAmaQuestionPromptResultSchema,
    exports.DocumentAmaUploadPromptResultSchema,
    exports.ExtractJsonPromptResultSchema,
    exports.VirtualSheetConfigPromptResultSchema,
    exports.TransformPromptResultSchema,
]);
exports.FinleyAiContextMetadataSchema = zod_1.z.union([
    exports.SqlGenerationContextMetadataSchema,
    exports.SqlExplainContextMetadataSchema,
    exports.DocumentAmaQuestionContextMetadataSchema,
    exports.DocumentAmaUploadContextMetadataSchema,
    exports.ExtractJsonContextMetadataSchema,
    exports.VirtualSheetConfigContextMetadataSchema,
    exports.TransformContextMetadataSchema,
]);
exports.FinleyAiSharedKnowledgeBaseDocumentUploadWorkleaseSchema = zod_1.z.object({
    type: zod_1.z.literal('sharedKnowledgeBaseDocumentUpload'),
    organizationIds: zod_1.z.array(zod_1.z.string()),
    userId: zod_1.z.string(),
    documentName: zod_1.z.string(), // name of document
    s3Bucket: zod_1.z.string(), // s3 bucket of document
    s3Path: zod_1.z.string(), // s3 path of document type
    // we currenly only support uploading creditAgreement with SharedKnowledgeBaseDocumentUploadWorklease
    documentType: zod_1.z.literal('creditAgreement'),
    tags: zod_1.z.array(zod_1.z.string()),
    creditFacilityDocumentId: zod_1.z.string(),
});
exports.FinleyAiPromptResponseWorkleaseSchema = zod_1.z.object({
    finleyAiPromptResponseId: zod_1.z.string(), // ref to finley_ai_prompt_responses.id
});
// Zod schema for FinleyAiStatusMetadata
exports.FinleyAiStatusMetadataSchema = zod_1.z
    .object({
    message: zod_1.z.string(),
    error: zod_1.z.string().nullable().optional(),
})
    .passthrough(); // allows additional properties
// Zod schema for FinleyAiPromptResponseStatus
exports.FinleyAiPromptResponseStatusIterable = [
    'initiated',
    'in-progress',
    'success',
    'failure',
];
exports.FinleyAiPromptResponseStatusSchema = zod_1.z.enum(exports.FinleyAiPromptResponseStatusIterable);
exports.FinleyAiPromptResponseTerminalStatuses = [
    'failure',
    'success',
];
/**
 * ************************************
 * TABLE DEFINITIONS
 * ************************************
 */
// Domain schema - for runtime use, outputs Date objects
exports.FinleyAiThreadSchema = zod_1.z.object({
    id: zod_1.z.string(),
    userId: zod_1.z.string(), // FK to users, the author and owner of this thread
    // FK to orgs - this is not necessarily the orgId of the owning userId, it represents the org
    // the thread is associated with from an entity standpoint, like generate a query for a acmeCorp table
    targetOrganizationId: zod_1.z.string(),
    type: exports.FinleyAiTypeSchema,
    // leaving nullable for now, we may decide to use finley ai to give the thread a title (like chatGPT)
    // for today, we will programmatically title the same as initial raw prompt
    title: zod_1.z.string().nullable(),
    created_at: typeguardUtils_1.zodDateTimeSchema,
    updated_at: typeguardUtils_1.zodDateTimeSchema,
});
// Wire schema - for JSON schema generation (Python codegen), outputs string dates
exports.FinleyAiThreadWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    userId: zod_1.z.string(),
    targetOrganizationId: zod_1.z.string(),
    type: exports.FinleyAiTypeSchema,
    title: zod_1.z.string().nullable(),
    created_at: typeguardUtils_1.zodDateTimeWireSchema,
    updated_at: typeguardUtils_1.zodDateTimeWireSchema,
});
/**
 * ************************************
 * ZOD SCHEMAS FOR PROMPT RESPONSE (FULL TYPES)
 * These have Date fields so we need wire/domain variants
 * ************************************
 */
// Base fields common to all prompt responses
const BasePromptResponseFieldsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    finleyAiThreadId: zod_1.z.string(),
    status: exports.FinleyAiPromptResponseStatusSchema,
    statusMetadata: exports.FinleyAiStatusMetadataSchema,
    awsBedrockModelId: zod_1.z.string().nullable(),
});
// Wire schema base (string dates for JSON schema generation)
const BasePromptResponseWireFieldsSchema = BasePromptResponseFieldsSchema.extend({
    created_at: typeguardUtils_1.zodDateTimeWireSchema,
    updated_at: typeguardUtils_1.zodDateTimeWireSchema,
});
// Domain schema base (Date objects for runtime use)
const BasePromptResponseDomainFieldsSchema = BasePromptResponseFieldsSchema.extend({
    created_at: typeguardUtils_1.zodDateTimeSchema,
    updated_at: typeguardUtils_1.zodDateTimeSchema,
});
// --- Individual PromptResponse Wire Schemas ---
exports.SqlGenerationPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    rawPrompt: exports.SqlGenerationRawPromptSchema,
    engineeredPrompt: exports.SqlGenerationEngineeredPromptSchema.nullable(),
    promptResult: exports.SqlGenerationPromptResultSchema.nullable(),
    contextMetadata: exports.SqlGenerationContextMetadataSchema,
});
exports.SqlExplainPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    rawPrompt: exports.SqlExplainRawPromptSchema,
    engineeredPrompt: exports.SqlExplainEngineeredPromptSchema.nullable(),
    promptResult: exports.SqlExplainPromptResultSchema.nullable(),
    contextMetadata: exports.SqlExplainContextMetadataSchema,
});
exports.DocumentAmaQuestionPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    rawPrompt: exports.DocumentAmaQuestionRawPromptSchema,
    engineeredPrompt: exports.DocumentAmaQuestionEngineeredPromptSchema.nullable(),
    promptResult: exports.DocumentAmaQuestionPromptResultSchema.nullable(),
    contextMetadata: exports.DocumentAmaQuestionContextMetadataSchema,
});
exports.DocumentAmaUploadPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    rawPrompt: exports.DocumentAmaUploadRawPromptSchema,
    engineeredPrompt: exports.DocumentAmaUploadEngineeredPromptSchema.nullable(),
    promptResult: exports.DocumentAmaUploadPromptResultSchema.nullable(),
    contextMetadata: exports.DocumentAmaUploadContextMetadataSchema,
});
exports.ExtractJsonPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    rawPrompt: exports.ExtractJsonRawPromptSchema,
    engineeredPrompt: exports.ExtractJsonEngineeredPromptSchema.nullable(),
    promptResult: exports.ExtractJsonPromptResultSchema.nullable(),
    contextMetadata: exports.ExtractJsonContextMetadataSchema,
});
exports.VirtualSheetConfigPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    rawPrompt: exports.VirtualSheetConfigRawPromptSchema,
    engineeredPrompt: exports.VirtualSheetConfigEngineeredPromptSchema.nullable(),
    promptResult: exports.VirtualSheetConfigPromptResultSchema.nullable(),
    contextMetadata: exports.VirtualSheetConfigContextMetadataSchema,
});
exports.TransformPromptResponseWireSchema = BasePromptResponseWireFieldsSchema.extend({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    rawPrompt: exports.TransformRawPromptSchema,
    engineeredPrompt: exports.TransformEngineeredPromptSchema.nullable(),
    promptResult: exports.TransformPromptResultSchema.nullable(),
    contextMetadata: exports.TransformContextMetadataSchema,
});
// Wire schema union - for JSON schema generation (Python codegen)
exports.FinleyAiPromptResponseWireSchema = zod_1.z.union([
    exports.SqlGenerationPromptResponseWireSchema,
    exports.SqlExplainPromptResponseWireSchema,
    exports.DocumentAmaQuestionPromptResponseWireSchema,
    exports.DocumentAmaUploadPromptResponseWireSchema,
    exports.ExtractJsonPromptResponseWireSchema,
    exports.VirtualSheetConfigPromptResponseWireSchema,
    exports.TransformPromptResponseWireSchema,
]);
// --- Individual PromptResponse Domain Schemas ---
exports.SqlGenerationPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlGeneration'),
    rawPrompt: exports.SqlGenerationRawPromptSchema,
    engineeredPrompt: exports.SqlGenerationEngineeredPromptSchema.nullable(),
    promptResult: exports.SqlGenerationPromptResultSchema.nullable(),
    contextMetadata: exports.SqlGenerationContextMetadataSchema,
});
exports.SqlExplainPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    subType: zod_1.z.literal('sqlExplain'),
    rawPrompt: exports.SqlExplainRawPromptSchema,
    engineeredPrompt: exports.SqlExplainEngineeredPromptSchema.nullable(),
    promptResult: exports.SqlExplainPromptResultSchema.nullable(),
    contextMetadata: exports.SqlExplainContextMetadataSchema,
});
exports.DocumentAmaQuestionPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('question'),
    rawPrompt: exports.DocumentAmaQuestionRawPromptSchema,
    engineeredPrompt: exports.DocumentAmaQuestionEngineeredPromptSchema.nullable(),
    promptResult: exports.DocumentAmaQuestionPromptResultSchema.nullable(),
    contextMetadata: exports.DocumentAmaQuestionContextMetadataSchema,
});
exports.DocumentAmaUploadPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('documentAma'),
    subType: zod_1.z.literal('upload'),
    rawPrompt: exports.DocumentAmaUploadRawPromptSchema,
    engineeredPrompt: exports.DocumentAmaUploadEngineeredPromptSchema.nullable(),
    promptResult: exports.DocumentAmaUploadPromptResultSchema.nullable(),
    contextMetadata: exports.DocumentAmaUploadContextMetadataSchema,
});
exports.ExtractJsonPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('extractValues'),
    subType: zod_1.z.literal('extractJson'),
    rawPrompt: exports.ExtractJsonRawPromptSchema,
    engineeredPrompt: exports.ExtractJsonEngineeredPromptSchema.nullable(),
    promptResult: exports.ExtractJsonPromptResultSchema.nullable(),
    contextMetadata: exports.ExtractJsonContextMetadataSchema,
});
exports.VirtualSheetConfigPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    subType: zod_1.z.literal('generateVirtualSheetConfig'),
    rawPrompt: exports.VirtualSheetConfigRawPromptSchema,
    engineeredPrompt: exports.VirtualSheetConfigEngineeredPromptSchema.nullable(),
    promptResult: exports.VirtualSheetConfigPromptResultSchema.nullable(),
    contextMetadata: exports.VirtualSheetConfigContextMetadataSchema,
});
exports.TransformPromptResponseSchema = BasePromptResponseDomainFieldsSchema.extend({
    type: zod_1.z.literal('transform'),
    subType: exports.TranformSubTypeSchemaEnum,
    rawPrompt: exports.TransformRawPromptSchema,
    engineeredPrompt: exports.TransformEngineeredPromptSchema.nullable(),
    promptResult: exports.TransformPromptResultSchema.nullable(),
    contextMetadata: exports.TransformContextMetadataSchema,
});
// Domain schema union - for runtime use
exports.FinleyAiPromptResponseSchema = zod_1.z.union([
    exports.SqlGenerationPromptResponseSchema,
    exports.SqlExplainPromptResponseSchema,
    exports.DocumentAmaQuestionPromptResponseSchema,
    exports.DocumentAmaUploadPromptResponseSchema,
    exports.ExtractJsonPromptResponseSchema,
    exports.VirtualSheetConfigPromptResponseSchema,
    exports.TransformPromptResponseSchema,
]);
/**
 * ************************************
 * ZOD SCHEMAS FOR THREAD WITH PROMPT RESPONSES
 * These have Date fields so we need wire/domain variants
 * ************************************
 */
// Wire schema variants (string dates)
exports.AthenaSqlGenerationThreadWithPromptResponsesWireSchema = exports.FinleyAiThreadWireSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    promptResponses: zod_1.z.array(zod_1.z.union([
        exports.SqlGenerationPromptResponseWireSchema,
        exports.SqlExplainPromptResponseWireSchema,
    ])),
});
exports.DocumentAmaThreadWithPromptResponsesWireSchema = exports.FinleyAiThreadWireSchema.extend({
    type: zod_1.z.literal('documentAma'),
    promptResponses: zod_1.z.array(zod_1.z.union([
        exports.DocumentAmaQuestionPromptResponseWireSchema,
        exports.DocumentAmaUploadPromptResponseWireSchema,
    ])),
});
exports.ExtractValuesWithPromptResponsesWireSchema = exports.FinleyAiThreadWireSchema.extend({
    type: zod_1.z.literal('extractValues'),
    promptResponses: zod_1.z.array(exports.ExtractJsonPromptResponseWireSchema),
});
exports.VirtualSheetConfigWithPromptResponsesWireSchema = exports.FinleyAiThreadWireSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    promptResponses: zod_1.z.array(exports.VirtualSheetConfigPromptResponseWireSchema),
});
exports.TranformWithPromptResponsesWireSchema = exports.FinleyAiThreadWireSchema.extend({
    type: zod_1.z.literal('transform'),
    promptResponses: zod_1.z.array(exports.TransformPromptResponseWireSchema),
});
// Wire schema union - for JSON schema generation (Python codegen)
exports.FinleyAiThreadWithPromptResponsesWireSchema = zod_1.z.union([
    exports.AthenaSqlGenerationThreadWithPromptResponsesWireSchema,
    exports.DocumentAmaThreadWithPromptResponsesWireSchema,
    exports.ExtractValuesWithPromptResponsesWireSchema,
    exports.VirtualSheetConfigWithPromptResponsesWireSchema,
    exports.TranformWithPromptResponsesWireSchema,
]);
// Domain schema variants (Date objects)
exports.AthenaSqlGenerationThreadWithPromptResponsesSchema = exports.FinleyAiThreadSchema.extend({
    type: zod_1.z.literal('athenaSqlGeneration'),
    promptResponses: zod_1.z.array(zod_1.z.union([
        exports.SqlGenerationPromptResponseSchema,
        exports.SqlExplainPromptResponseSchema,
    ])),
});
exports.DocumentAmaThreadWithPromptResponsesSchema = exports.FinleyAiThreadSchema.extend({
    type: zod_1.z.literal('documentAma'),
    promptResponses: zod_1.z.array(zod_1.z.union([
        exports.DocumentAmaQuestionPromptResponseSchema,
        exports.DocumentAmaUploadPromptResponseSchema,
    ])),
});
exports.ExtractValuesWithPromptResponsesSchema = exports.FinleyAiThreadSchema.extend({
    type: zod_1.z.literal('extractValues'),
    promptResponses: zod_1.z.array(exports.ExtractJsonPromptResponseSchema),
});
exports.VirtualSheetConfigWithPromptResponsesSchema = exports.FinleyAiThreadSchema.extend({
    type: zod_1.z.literal('virtualSheetConfig'),
    promptResponses: zod_1.z.array(exports.VirtualSheetConfigPromptResponseSchema),
});
exports.TranformWithPromptResponsesSchema = exports.FinleyAiThreadSchema.extend({
    type: zod_1.z.literal('transform'),
    promptResponses: zod_1.z.array(exports.TransformPromptResponseSchema),
});
// Domain schema union - for runtime use
exports.FinleyAiThreadWithPromptResponsesSchema = zod_1.z.union([
    exports.AthenaSqlGenerationThreadWithPromptResponsesSchema,
    exports.DocumentAmaThreadWithPromptResponsesSchema,
    exports.ExtractValuesWithPromptResponsesSchema,
    exports.VirtualSheetConfigWithPromptResponsesSchema,
    exports.TranformWithPromptResponsesSchema,
]);
const SupportedFinleyAiPromptTemplatesSchema = zod_1.z.enum([
    'sqlGeneration',
    'sqlExplain',
    'question',
    'upload',
    'extractJson',
    'generateVirtualSheetConfig',
    'modifyVirtualSheetConfig',
    'generalTransform',
    'financialStatement',
    'questionTool',
]);
const FinleyAiPromptTemplateTypeSchema = zod_1.z.enum(['instructions', 'examples']);
exports.FinleyAiPromptTemplateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    finleyAiType: exports.FinleyAiTypeSchema,
    finleyAiSubType: SupportedFinleyAiPromptTemplatesSchema,
    templateType: FinleyAiPromptTemplateTypeSchema,
    text: zod_1.z.string(),
});
const FinleyAiKnowledgeBaseDocumentTypeSchema = zod_1.z.enum([
    'creditAgreement',
    'userProvided',
]);
exports.FinleyAiKnowledgeBaseDocumentSchema = zod_1.z.object({
    id: zod_1.z.string(), // document id
    documentName: zod_1.z.string(), // name of document
    s3Bucket: zod_1.z.string(), // s3 bucket of document
    s3Path: zod_1.z.string(), // s3 path of document type
    documentType: FinleyAiKnowledgeBaseDocumentTypeSchema,
    tags: zod_1.z.array(zod_1.z.string()),
    organizationId: zod_1.z.string(), // organizationId that owns the document
    userId: zod_1.z.string(), // userId that uploaded document, may be finley userId
    embeddedChunksS3Bucket: zod_1.z.string(),
    embeddedChunksS3Path: zod_1.z.string(),
});
//# sourceMappingURL=FinleyAi.js.map